<template>
	<div class="container">
		<div class="row">
			<sidebar></sidebar>
			<div class="col-sm-9">
				<section class="account-section">
					<h2>Favoritos</h2>
					<div class="row favorites-cards">
						<div class="col-sm-6 col-md-4" v-for="favorite in wish_list | paginate $route.query.page per_page" :product="favorite.product">
							<card :product="favorite.product"></card>
						</div>
					</div>
					<p class="text-general" v-if="!render_favorites.length">No tienes productos favoritos. Navega por nuestro 
						<a v-link="{ path: '/almacenamiento?page=1'}">Catálogo en Línea</a> para agregar productos
					</p>
					<pagination :url="url" :items="wish_list" :per_page="per_page"></pagination>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/User/Breadcrumb.vue';
import Sidebar from '../../components/User/Sidebar.vue';
import Pagination from '../../components/Pagination.vue';
import Card from '../../components/Home/Card.vue';

export default {
	data () {
		return {
			url: '/favoritos?page=',
			per_page: 9
		}
	},

	vuex: {
		getters: {
			products: state => state.products,
			wish_list: state => {
				let products = state.products;
				let wish_list = state.wish_list;

				for (let i = 0, p = products; i < p.length; i++) {
					for (let j = 0, w = wish_list; j < w.length; j++) {
						if (p[i].id == w[j].product_id) {
							w[j].product.images = p[i].images;
						}
					}
				}
				
				return wish_list;
			}
		}
	},

	computed: {
		render_favorites() {
			return this.wish_list;
		}
	},

	components: {
		Breadcrumb,
		Sidebar,
		Card,
		Pagination
	}
};
</script>


// WEBPACK FOOTER //
// Favorites.vue?7806db4b